import { useBreakpointValue } from '@chakra-ui/react';
import { useServerContext } from '@salesforce/pwa-kit-react-sdk/ssr/universal/hooks';
import { isServer } from '@tanstack/react-query';
import { isMobileServerSide } from './utils';

/**
 * Hook that returns a boolean value indicating if the current device is mobile.
 * On the server side it tries to determine based of sec-ch-ua-mobile, sec-ch-viewport-width and user-agent headers. In case it can't determine it returns undefined.
 * On the client side it uses Chakra UI's useBreakpointValue hook.
 * @returns {boolean|undefined}
 */

export const useIsMobile = (): boolean | undefined => {
    const { req } = useServerContext();

    const isClientMobile = useBreakpointValue({ base: true, md: false }, { ssr: isServer });

    return isServer ? isMobileServerSide(req.headers) : isClientMobile;
};
